import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import { defaults as defaultControls } from 'ol/control';
import MapBaseOperate from '@/utils/olMapOperate';
import { MapLayerEnum } from '@/utils/enum';
import { Tile } from 'ol/layer';
import XYZ from 'ol/source/XYZ';
import HighPrecisionBtn from '../HighPrecisionBtn';
import { map } from 'lodash';
import { fromLonLat } from 'ol/proj';

const StandardTileMap = ({
  latitude,
  longitude,
  zoom,
  forceAllHighPrecisionMapVisible = false,
  getMapRef,
  getMapContainerRef,
}: {
  latitude: number;
  longitude: number;
  zoom?: number;
  forceAllHighPrecisionMapVisible?: boolean;
  getMapRef: (map: Map) => void;
  getMapContainerRef?: (container: HTMLDivElement) => void;
}) => {
  const mapRef = useRef<any>(null); // 地图实例
  const mapContainerRef = useRef<any>(null); // 地图的dom元素
  const mapOperateRef = useRef<any>(null); // 地图操作方法的类的实例
  const initMap = async () => {
    if (longitude && latitude) {
      if (!mapRef.current) {
        // 将经纬度值的坐标转化为平面投影的坐标
        const currentCenterLonLat = fromLonLat([longitude, latitude]);
        mapRef.current = new Map({
          target: mapContainerRef.current,
          controls: defaultControls({ rotate: false }),
          view: new View({
            center: currentCenterLonLat,
            // 采用平面投影而非曲面投影(EPSG:4326), 防止ol内部做重投影
            projection: 'EPSG:3857',
            zoom: zoom ?? 15,
            maxZoom: 22,
            minZoom: 5,
            constrainRotation: true,
            rotation: 0,
            enableRotation: false,
          }),
        });
        if (getMapRef) {
          getMapRef(mapRef.current);
        }

        // 调用 getMapContainerRef 回调函数传递地图容器引用
        if (getMapContainerRef && mapContainerRef.current) {
          getMapContainerRef(mapContainerRef.current);
        }

        mapOperateRef.current = new MapBaseOperate(mapRef.current);

        mapOperateRef.current.addLayers([
          {
            layer: createBaseMapLayer(),
            layerId: MapLayerEnum.TECENTMAP_LAYER,
          },
        ]);
      }
    }
  };

  useEffect(() => {
    if (longitude && latitude && !mapRef.current) {
      initMap();
    }
  }, [longitude, latitude]);

  useEffect(() => {
    return () => {
      if (mapOperateRef.current) {
        mapOperateRef.current = null;
      }
      if (mapRef.current) {
        mapRef.current.setTarget(null);
        mapRef.current.dispose?.();
        mapRef.current = null;
      }
    };
  }, []);

  const createBaseMapLayer = () => {
    return new Tile({
      source: new XYZ({
        url: 'https://rt3.map.gtimg.com/tile?z={z}&x={x}&y={-y}&type=vector&styleid=4',
        maxZoom: 18,
        interpolate: true,
      }),
    });
  };

  return (
    <div className="standard-tile-map-container">
      <div className="tile-map-container" ref={mapContainerRef}></div>
      <HighPrecisionBtn
        mapOperateRef={mapOperateRef}
        forceAllVisible={forceAllHighPrecisionMapVisible}
        latitude={latitude}
        longitude={longitude}
      />
    </div>
  );
};

export default React.memo(StandardTileMap);
